<nav class="module-nav" [attr.aria-label]="navAriaLabel()">
  <div class="module-nav__logo" aria-hidden="true">
    <app-icon icon="logo-safegpt-brand.svg" [width]="40" [height]="40" />
  </div>

  <div class="module-nav__items">
    @for (item of navigationItems; track item.route) {
      <a class="nav-item" [routerLink]="item.route" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }" [attr.aria-label]="item.label()"
        [appTooltip]="item.label()" appTooltipPosition="right" [appTooltipDisabled]="isMobile()">
        <span class="nav-item__line" aria-hidden="true"></span>
        <span class="nav-item__inner">
          <i class="nav-icon" [class]="item.icon" aria-hidden="true"></i>
        </span>
      </a>
    }
  </div>

  <div class="module-nav__footer">
    <button type="button" class="module-nav__avatar-trigger" (click)="toggleProfileMenu($event)"
      [attr.aria-label]="openProfileMenuLabel()" [attr.aria-expanded]="isProfileMenuOpen()">
      <span class="module-nav__avatar">{{ userInitials() }}<span class="module-nav__presence" [class.module-nav__presence--available]="agentAvailable()" aria-hidden="true"></span></span>
    </button>

    <app-profile-menu class="profile-menu-host" (closed)="closeProfileMenu()"
      [class.profile-menu-host--open]="isProfileMenuOpen()" />
  </div>
</nav>
